// Generated by CoffeeScript 1.12.4
var Toast, _, failureMessages, stub, successMessages;

require('angular-animate');

require('angular-sanitize');

_ = require('lodash');

successMessages = ['Great success!', 'Make it so!', 'Strong work!', 'Hooray!'];

failureMessages = ['Houston, we have a problem...', 'Tough luck', "It's a trap!"];

stub = {
  success: null,
  info: null,
  warning: null,
  danger: null
};

module.exports = Toast = Toast = (function() {
  function Toast(ngToast) {
    this.ngToast = ngToast;
  }

  Toast.prototype.success = function(msg, options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    if (msg == null) {
      msg = _.sample(successMessages);
    }
    if (stub.success != null) {
      msg = stub.success;
    }
    return this.ngToast.success(_.assign({
      content: msg
    }, options));
  };

  Toast.prototype.successCB = function(msg, options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    return (function(_this) {
      return function() {
        return _this.success(msg, options);
      };
    })(this);
  };

  Toast.prototype.fail = function(msg, options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    if (msg == null) {
      msg = _.sample(failureMessages);
    }
    if (stub.danger != null) {
      msg = stub.danger;
    }
    return this.ngToast.danger(_.assign({
      content: msg
    }, options));
  };

  Toast.prototype.failCB = function(msg, options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    return (function(_this) {
      return function() {
        return _this.fail(msg, options);
      };
    })(this);
  };

  Toast.prototype.serverFailCB = function(options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    return (function(_this) {
      return function(res) {
        var ref;
        return _this.fail(((ref = res.data) != null ? ref.message : void 0) || ("Server error (" + res.status + ")"), options);
      };
    })(this);
  };

  Toast.prototype.warn = function(msg, options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    if (msg == null) {
      throw new Error('Please provide toast message');
    }
    if (stub.warning != null) {
      msg = stub.warning;
    }
    return this.ngToast.warning(_.assign({
      content: msg
    }, options));
  };

  Toast.prototype.info = function(msg, options) {
    if (options == null) {
      options = Toast.defaultOptions;
    }
    if (msg == null) {
      throw new Error('Please provide toast message');
    }
    if (stub.info != null) {
      msg = stub.info;
    }
    return this.ngToast.info(_.assign({
      content: msg
    }, options));
  };

  return Toast;

})();

Toast.defaultOptions = {
  dismissButton: true
};

Toast.stub = function(arg) {
  var danger, info, success, warning;
  success = arg.success, info = arg.info, warning = arg.warning, danger = arg.danger;
  stub.success = success || null;
  stub.info = info || null;
  stub.warning = warning || null;
  return stub.danger = danger || null;
};

Toast.restore = function() {
  return stub = {
    success: null,
    info: null,
    warning: null,
    danger: null
  };
};
